<template>
  <div class="document-cover-page" :class="coverClass" :style="{ 'color': payload.cover.color, 'background-color': payload.cover.backgroundColor, 'font-family': payload.options.documentFont }">
    <span class="has-bg-img" :style="{ 'background-image': 'url(' + payload.cover.backgroundImage + ')' }" v-if="payload.cover.backgroundImage"></span>

    <div class="document-cover-page-content" :class="classes">

      <div class="company-logo" :class="{ hover: state === 'editor' }">
        <dropzone @upload="updateLogo" v-if="!payload.cover.logo && state === 'editor'" default-message="Drag & drop your logo here or choose a file from your computer ... (optional)"></dropzone>
        <span v-if="payload.cover.logo && state !== 'preview'" class="edit-wrapper"><i class="icon icon-edit" @click="resetDropzone()"></i></span>
        <img :src="payload.cover.logo" v-show="payload.cover.logo" @click="resetDropzone()">
      </div>

      <textarea data-gramm="false" ref="title" id="document-title-input" class="document-title-input" v-model="payload.cover.title" :style="{ 'color': payload.cover.color }" :disabled="state !== 'editor'"></textarea>
      <textarea data-gramm="false" ref="client" id="client-input" class="client-input" v-model="payload.cover.client" :style="{ 'color': payload.cover.color }" placeholder="Add company name..." :disabled="state !== 'editor'" v-if="payload.cover.client || state === 'editor'"></textarea>

      <span class="created-by" v-if="payload.cover.createdBy || state === 'editor'">
        <strong contenteditable="false" :style="{ 'color': payload.cover.color }">Created by:</strong>
        <input type="text" id="created-by-input" class="created-by-input" v-model="payload.cover.createdBy" placeholder="Jane Doe" :style="{ 'color': payload.cover.color }" :size="payload.cover.createdBy && payload.cover.createdBy.length > 20 ? payload.cover.createdBy.length : 20" :disabled="state !== 'editor'">
      </span>
      <span class="created-for" v-if="payload.cover.createdFor || state === 'editor'">
        <strong contenteditable="false" :style="{ 'color': payload.cover.color }">Created for:</strong>
        <input type="text" id="created-for-input"  class="created-for-input" v-model="payload.cover.createdFor" placeholder="Add recipient's name..." :style="{ 'color': payload.cover.color }" :size="payload.cover.createdFor && payload.cover.createdFor.length > 20 ? cover.createdFor.length : 20" :disabled="state !== 'editor'">
      </span>

    </div>
  </div>
</template>

<script>
  export default {
    props: ['payload', 'state'],
    data() {
      return {
        coverClass: this.payload.cover.themeName
      }
    },
    mounted() {
      this.autoHeight(this.$refs.title);
      this.autoHeight(this.$refs.client);
    },
    methods: {
      autoHeight($el) {
        if (!$el || !$el.style) { return; }
        $el.style.height = '5px';
        $el.style.height = ($el.scrollHeight) + 'px';
      },
      updateLogo(upload) {
        this.$set(this.payload.cover, 'logo', upload.url);
      },
      resetDropzone() {
        if (this.state === 'editor') {
          this.$set(this.payload.cover, 'logo', null);
        }
      }
    },
    computed: {
      classes() {
        return {
          'layout-1': this.payload.cover.layout === 1,
          'layout-2': this.payload.cover.layout === 2,
          'layout-3': this.payload.cover.layout === 3,
          'layout-4': this.payload.cover.layout === 4,
          'alignment-left': this.payload.cover.alignment === 'left',
          'alignment-center': !this.payload.cover.alignment || this.payload.cover.alignment === 'center',
        };
      }
    },
    watch: {
      'payload.cover.themeName': {
        handler() {
          this.coverClass = this.payload.cover.themeName;
        }
      },
      'payload.cover.title': {
        handler() {
          this.autoHeight(this.$refs.title);
        }
      },
      'payload.cover.client': {
        handler() {
          this.autoHeight(this.$refs.client);
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "resources/assets/sass/layout/_variables";

  .document-cover-page {
    width: 800px;
    margin: 68px auto 0 auto;
    * {
      font-family: inherit;
    }
  }

  .company-logo {
    position: relative;
    .edit-wrapper {
      z-index: 1001;
      display: none;
      position: absolute;
      left: 50%;
      top: 50%;
      background: $green;
      border-radius: 100px;
      width: 50px;
      height: 50px;
      margin-left: -25px;
      margin-top: -25px;
      text-align: center;
      color: $white;
      padding-top: 13px;
      padding-right: 4px;
      &:hover {
        cursor: pointer;
      }
    }
    // Scope hover effect to editor only
    &.hover {
      &:hover {
        .edit-wrapper {
          display: block;
          &:hover {
            background: darken($green, 10%);
          }
        }
        img {
          opacity: 0.3;
          &.preview {
            opacity: 1;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// cover.vue?4ff25289